// @flow
import { styled } from 'mz-ui-kit';

export const BannerWrapper = styled('div', {
  width: '100%',
  margin: '0 auto 40px auto',
  maxWidth: '920px'
});
